import { gql } from '@apollo/client';

const schema = {
  changeStatus: {
    name: 'updateOrder',
    serviceName: 'auth',
    query: gql`
      mutation updateOrder($ids: [String]!, $status_id: String) {
        updateOrder(ids: $ids, status_id: $status_id) {
          messages
        }
      }
    `,
  },
};

export default schema;
